import { useState, useEffect, useCallback } from 'react'
import axios from 'axios'
import { useUI } from '../contexts/UIContext'

const API = process.env.REACT_APP_API_URL || 'http://localhost:3001/api'

interface WidgetDef { id: string; label: string; icone: string }

const fmt = (n: any) => (n !== null && n !== undefined) ? `R$ ${parseFloat(n).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}` : '—'
const fmtLitros = (n: any) => (n !== null && n !== undefined) ? `${parseFloat(n).toLocaleString('pt-BR', { minimumFractionDigits: 2 })} L` : '—'
const fmtData = (d: any) => d ? new Date(d).toLocaleDateString('pt-BR') : '—'
const fmtDataHora = (d: any) => d ? new Date(d).toLocaleString('pt-BR') : '—'

export default function PainelPersonalizavel() {
  const { toast } = useUI()
  const [disponiveis, setDisponiveis] = useState<WidgetDef[]>([])
  const [ativos, setAtivos] = useState<string[]>([])
  const [dados, setDados] = useState<Record<string, any>>({})
  const [carregando, setCarregando] = useState(true)
  const [modalAberto, setModalAberto] = useState(false)
  const [selecaoTemp, setSelecaoTemp] = useState<Set<string>>(new Set())

  const token = localStorage.getItem('moobi_token')
  const headers = { Authorization: `Bearer ${token}` }

  const carregar = useCallback(async () => {
    setCarregando(true)
    try {
      const [wDisp, wPref, wDados] = await Promise.all([
        axios.get(`${API}/dashboard/widgets`, { headers }),
        axios.get(`${API}/dashboard/widgets-preferencia`, { headers }),
        axios.get(`${API}/dashboard/widgets-dados`, { headers }),
      ])
      setDisponiveis(wDisp.data)
      setAtivos(wPref.data.widgets_ativos)
      setDados(wDados.data)
    } catch {
      toast('Erro ao carregar painel personalizável', 'error')
    } finally {
      setCarregando(false)
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => { carregar() }, [carregar])

  const abrirPersonalizar = () => {
    setSelecaoTemp(new Set(ativos))
    setModalAberto(true)
  }

  const salvarPersonalizacao = async () => {
    const novaLista = Array.from(selecaoTemp)
    try {
      await axios.put(`${API}/dashboard/widgets-preferencia`, { widgets_ativos: novaLista }, { headers })
      setAtivos(novaLista)
      setModalAberto(false)
      toast('Painel atualizado', 'success')
    } catch {
      toast('Erro ao salvar preferências', 'error')
    }
  }

  if (carregando) return null

  const widgetsVisiveis = disponiveis.filter(w => ativos.includes(w.id))

  return (
    <div style={{ marginTop: 24 }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
        <div style={{ fontSize: 13, fontWeight: 700, color: '#f1f5f9', display: 'flex', alignItems: 'center', gap: 6 }}>
          <i className="ph-bold ph-squares-four" style={{ color: '#0ea5e9' }} />
          Painel personalizável
        </div>
        <button onClick={abrirPersonalizar}
          style={{ background: '#1e2f4a', border: '1px solid #2d4166', borderRadius: 8, color: '#94a3b8',
            padding: '6px 12px', cursor: 'pointer', fontSize: 12, display: 'flex', alignItems: 'center', gap: 6 }}>
          <i className="ph-bold ph-sliders-horizontal" style={{ fontSize: 13 }} />
          Personalizar
        </button>
      </div>

      {widgetsVisiveis.length === 0 ? (
        <div style={{ background: '#0f172a', border: '1px dashed #2d4166', borderRadius: 10, padding: 20, textAlign: 'center', color: '#64748b', fontSize: 12 }}>
          Nenhum widget selecionado. Clique em "Personalizar" para escolher o que exibir aqui.
        </div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: 12 }}>
          {widgetsVisiveis.map(w => (
            <WidgetCard key={w.id} widget={w} dado={dados[w.id]} />
          ))}
        </div>
      )}

      {modalAberto && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', zIndex: 2000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          onClick={() => setModalAberto(false)}>
          <div style={{ background: '#0f172a', border: '1px solid #1e293b', borderRadius: 10, width: 400, maxWidth: '90vw', padding: 20 }}
            onClick={e => e.stopPropagation()}>
            <div style={{ fontSize: 14, fontWeight: 700, color: '#f1f5f9', marginBottom: 4 }}>Personalizar painel</div>
            <div style={{ fontSize: 11, color: '#64748b', marginBottom: 14 }}>Escolha quais widgets você quer ver aqui.</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 18 }}>
              {disponiveis.map(w => (
                <label key={w.id} style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, color: '#e2e8f0', cursor: 'pointer' }}>
                  <input type="checkbox" checked={selecaoTemp.has(w.id)}
                    onChange={() => setSelecaoTemp(prev => {
                      const novo = new Set(prev)
                      if (novo.has(w.id)) novo.delete(w.id); else novo.add(w.id)
                      return novo
                    })}
                    style={{ width: 14, height: 14, accentColor: '#0ea5e9' }} />
                  <i className={`ph-bold ph-${w.icone}`} style={{ color: '#64748b' }} />
                  {w.label}
                </label>
              ))}
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              <button onClick={() => setModalAberto(false)}
                style={{ flex: 1, padding: 9, borderRadius: 8, border: '1px solid #2d4166', background: 'transparent', color: '#94a3b8', cursor: 'pointer', fontSize: 13 }}>
                Cancelar
              </button>
              <button onClick={salvarPersonalizacao}
                style={{ flex: 1, padding: 9, borderRadius: 8, border: 'none', background: '#0ea5e9', color: '#fff', fontWeight: 700, cursor: 'pointer', fontSize: 13 }}>
                Salvar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

function CardBase({ titulo, icone, children }: { titulo: string; icone: string; children: React.ReactNode }) {
  return (
    <div style={{ background: '#0f172a', border: '1px solid #1e293b', borderRadius: 10, padding: 16 }}>
      <div style={{ fontSize: 11, color: '#64748b', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 10, display: 'flex', alignItems: 'center', gap: 6 }}>
        <i className={`ph-bold ph-${icone}`} />{titulo}
      </div>
      {children}
    </div>
  )
}

// Cada widget sabe renderizar seu próprio conteúdo a partir do dado bruto
// vindo de /dashboard/widgets-dados. Para adicionar um widget novo no
// futuro, basta acrescentar um `case` aqui — o resto do painel (grid,
// modal de personalização, persistência) já funciona automaticamente.
function WidgetCard({ widget, dado }: { widget: WidgetDef; dado: any }) {
  switch (widget.id) {
    case 'abastecimento_mes':
      return (
        <CardBase titulo={widget.label} icone={widget.icone}>
          {!dado ? <span style={{ fontSize: 12, color: '#64748b' }}>Sem dados</span> : (
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
              <div>
                <div style={{ fontSize: 18, fontWeight: 700, color: '#4ade80' }}>{fmt(dado.totalGasto)}</div>
                <div style={{ fontSize: 10, color: '#64748b' }}>Gasto no mês</div>
              </div>
              <div>
                <div style={{ fontSize: 18, fontWeight: 700, color: '#38bdf8' }}>{fmtLitros(dado.totalLitros)}</div>
                <div style={{ fontSize: 10, color: '#64748b' }}>{dado.quantidade} abastecimento(s)</div>
              </div>
            </div>
          )}
        </CardBase>
      )
    case 'docs_vencendo':
      return (
        <CardBase titulo={widget.label} icone={widget.icone}>
          {!dado || dado.length === 0 ? (
            <span style={{ fontSize: 12, color: '#64748b' }}>Nada vencendo nos próximos 30 dias</span>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 6, maxHeight: 140, overflowY: 'auto' }}>
              {dado.map((a: any) => {
                // o servidor ja devolve o documento que vence primeiro (IPVA/licenciamento = ultimo pagamento + 1 ano)
                const proxima = a.vencimento || [a.venc_ipva_licenciamento, a.venc_seguro, a.venc_revisao, a.venc_tacografo].filter(Boolean).sort()[0]
                return (
                  <div key={a.id} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 11 }}>
                    <span style={{ color: '#e2e8f0' }}>{a.nome}{a.placa ? ` · ${a.placa}` : ''}</span>
                    <span style={{ color: '#fbbf24' }}>{a.documento ? `${a.documento} · ` : ''}{fmtData(proxima)}</span>
                  </div>
                )
              })}
            </div>
          )}
        </CardBase>
      )
    case 'comandos_recentes':
      return (
        <CardBase titulo={widget.label} icone={widget.icone}>
          {!dado || dado.length === 0 ? (
            <span style={{ fontSize: 12, color: '#64748b' }}>Nenhum comando recente</span>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 6, maxHeight: 140, overflowY: 'auto' }}>
              {dado.map((c: any) => (
                <div key={c.id} style={{ fontSize: 11 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <span style={{ color: '#e2e8f0' }}>{c.ativo_nome}</span>
                    <span style={{ color: '#64748b' }}>{fmtDataHora(c.criado_em)}</span>
                  </div>
                  <div style={{ color: '#475569', fontFamily: 'monospace', fontSize: 10 }}>{c.comando}</div>
                </div>
              ))}
            </div>
          )}
        </CardBase>
      )
    default:
      // Widget cadastrado no backend mas ainda sem renderer no frontend —
      // não deveria acontecer em uso normal, mas evita tela quebrada.
      return (
        <CardBase titulo={widget.label} icone={widget.icone}>
          <span style={{ fontSize: 12, color: '#64748b' }}>Em breve</span>
        </CardBase>
      )
  }
}
